module.exports = __webpack_public_path__ + "img/Folded_Paper_icon_deliver.9e318bc1.svg";